import { gql } from '@apollo/client';

export const GET_PLACES_AUTOCOMPLETE = gql`
  query getPlacesAutocomplete($input: PlacesAutocompleteInput) {
    getPlacesAutocomplete(input: $input) {
      places {
        placeId
        description
      }
    }
  }
`;
